/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type PdpSharedSoldHeader_item$ref = any;
export type PdpSharedSoldHeader_item = {
    readonly title: string | null;
    readonly " $refType": PdpSharedSoldHeader_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedSoldHeader_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = 'c0c9b105f2020f354db053081c15af1d';
export default node;
